import {I18n} from "i18n-js"

const i18n = new I18n()

i18n.locale = window.gon.locale
i18n.defaultLocale = window.gon.defaultLocale
i18n.missingBehavior = "error"

global.I18n = i18n

export default i18n
